import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SelectedFilter } from 'app/features/shared/component/filter/filter-model';

@Injectable({
    providedIn: 'root'
})
export class MeasurementListFilterService {
    private readonly filterSubject = new BehaviorSubject<SelectedFilter | null>(null);
    public readonly filter$ = this.filterSubject.asObservable();

    public setFilter(filter: SelectedFilter): void {
        this.filterSubject.next(filter);
    }

    public get currentFilter(): SelectedFilter | null {
        return this.filterSubject.value;
    }
}
